import moment from "moment";

const schema = {
    selected_application: {},
    authenticated:false,
    current_user:null,
    doc_templates: {
        "templates": [
            {
                "id": 1,
                "name": "AusloansPrivacyConsent",
                "extension": "docx",
                "url": "app/public/templates/",
                "type": "template",
                "description": "Ausloans Privacy Consent ..."
            },
            {
                "id": 2,
                "name": "AusloansPrivacyConsent_Manu_Fin",
                "extension": "docx",
                "url": "app/public/templates/",
                "type": "template",
                "description": "Ausloans Privacy Consent Manu Fin."
            },
            {
                "id": 3,
                "name": "Checklist",
                "extension": "docx",
                "url": "app/public/templates/",
                "type": "template",
                "description": "Check List."
            },
            {
                "id": 4,
                "name": "Comprehensive Insurance Disclosure Notice",
                "extension": "docx",
                "url": "app/public/templates/",
                "type": "template",
                "description": "Comprehensive Insurance Disclosure Notice."
            },
            {
                "id": 5,
                "name": "Credit Guide",
                "extension": "docx",
                "url": "app/public/templates/",
                "type": "template",
                "description": "Credit Guide"
            },
            {
                "id": 6,
                "name": "Credit Guide Online Privacy",
                "extension": "docx",
                "url": "app/public/templates/",
                "type": "template",
                "description": "Credit Guide Online Privacy"
            },
            {
                "id": 7,
                "name": "Credit Guide Template",
                "extension": "docx",
                "url": "app/public/templates/",
                "type": "template",
                "description": "Credit Guide Template"
            },
            {
                "id": 8,
                "name": "Credit Guide Verbal Privacy",
                "extension": "docx",
                "url": "app/public/templates/",
                "type": "template",
                "description": "Credit Guide Verbal Privacy"
            },
            {
                "id": 9,
                "name": "Credit Proposal",
                "extension": "docx",
                "url": "app/public/templates/",
                "type": "template",
                "description": "Credit Proposal"
            },
            {
                "id": 10,
                "name": "Credit Quote",
                "extension": "docx",
                "url": "app/public/templates/",
                "type": "template",
                "description": "Credit Quote"
            },
            {
                "id": 11,
                "name": "Deal Commission Sheet",
                "extension": "docx",
                "url": "app/public/templates/",
                "type": "template",
                "description": "Deal Commission Sheet"
            },
            {
                "id": 12,
                "name": "Mandatory Disclosure Notice",
                "extension": "docx",
                "url": "app/public/templates/",
                "type": "template",
                "description": "Mandatory Disclosure Notice"
            },
            {
                "id": 13,
                "name": "Preliminary Assessment",
                "extension": "docx",
                "url": "app/public/templates/",
                "type": "template",
                "description": "Preliminary Assessment"
            },
            {
                "id": 14,
                "name": "Preliminary Assessment Summary",
                "extension": "docx",
                "url": "app/public/templates/",
                "type": "template",
                "description": "Preliminary Assessment Summary"
            },
            {
                "id": 15,
                "name": "Verbal Privacy Consent",
                "extension": "docx",
                "url": "app/public/templates/",
                "type": "template",
                "description": "Verbal Privacy Consent"
            }
        ]
    }
}

function newPhone(type){
    return {
        "type": type,
        "phone_number": ""
    };
}

function newEmail(){
    return {
        "email": ""
    };
}

function newIdentification(type='License'){
  return {
      "type": type,
      "id_number": "",
      "card_number": "",
      "expiry_date": "",
      "state_of_issue": "",
      "country_of_issue": "",
      "image": null,
      "license_type": "",
  };
}

function newAddress(){
  return {
    "same_as_residential": false,
    "type": "House",
    "full_address": "",
    "unit": "",
    "street_number": "",
    "street_name": "",
    "street_type": "",
    "suburb": "",
    "state": null,
    "post_code": "",
    "country": "Australia"
  };
}

function newAddressHistory(){
    return {
        "ownership":"Rented",
        "address": newAddress(),
        "duration": {
            "years": null,
            "months": null
        },
        "expense": {
            "amount": null,
            "frequency": "Weekly"
        },
        "landlord": {
          "name": "",
          "phone_number": "",
          "address": newAddress()
        }
    };
}

function newEmployment(){
    return {
        "type": null,
        "employer_details": {
            "name": "",
            "abn": "",
            "acn": "",
            "contact_name": "",
            "contact_number": "",
            "abn_registration_date": "",
            "gst_registration_date": ""
        },
        "address": newAddress(),
        "occupation": "",
        "title": "",
        "industry": "",
        "probation": false,
        "duration": {
            "years": null,
            "months": null
        },
        "income": {
            "amount": null,
            "frequency": "Weekly"
        }
    };
}

function newIncome(type=''){
    return {
        "type": type,
        "amount": null,
        "frequency": "Weekly"
    };
}

function newDocuRoleName(){
  return {
      "docusign_rolename": null,
      "zink_rolename": null,
      "include_docusign_role": false
  };
}
function newExpense(type=''){
    return {
        "type": type,
        "amount": null,
        "frequency": "Weekly",
        "is_company_expenses":false
    };
}

function newAsset(type=''){
    return {
        "type": type,
        "value": "",
        "joint": false,
        "finance": {
            "provider": "",
            "outstanding_amount": "",
            "original_amount": "",
            "duration": {
                "years": "",
                "months": ""
            }
        },
        "income": {
            "amount": "",
            "frequency": "Weekly"
        },
        "expense": {
            "amount": "",
            "frequency": "Weekly"
        },
        "description": "",
        "has_value": false,
        "has_liability": false,
        "has_income": false,
        "has_trade_in": false,
        "address": newAddress(),
    };
}

function newReference(){
    return {
        "relationship": "",
        "name": "",
        "phone": "",
        "email": "",
        "comment": "",
        "full_address": "",
        "is_emergency_contact":false,
    };
}

function newComment(){
    return {
        "tag": "",
        "content": "",
    };
}

function newInsurance(type='', name=null, allows_pbtm=false, has_term=true){
    return {
      "type": type,
      "type_name": name || type,
      "enabled": 0,
      "insurer": null,
      "policy": null,
      "policy_number": null,
      "term": null,
      "policy_start_date": null,
      "policy_end_date": null,
      "premium": null,
      "pbtm": 0,
      "income": null,
      "allows_pbtm": allows_pbtm,
      "has_term": has_term,
      "include_in_naf": false,
    };
}

function newApplicant(){
    return {
      "contact": {
        "id": null,
        "name": {
          "title": "",
          "firstname": "",
          "middlename": "",
          "lastname": ""
        },
        "date_of_birth": "",
        "gender": "Unspecified",
        "emails": [ newEmail() ],
        "phones": [
          newPhone('Mobile'),
          newPhone('Home'),
          newPhone('Work'),
        ],
      },
      "personal_details": {
        "identifications": [ newIdentification() , newIdentification('Passport'),newIdentification('Medicare')],
        "residency": "",
        "number_of_dependants": 0,
        "dependants_details": [],
        "marital_status": "",
        "spouse_index": null,
        "spouse": {
          "name": {
            "title": null,
            "firstname": "",
            "middlename": null,
            "lastname": ""
          },
          "employment": {
            "type": "",
            "employer_name": "",
            "duration": {
              "years": null,
              "months": null
            },
            "income": {
              "amount": null,
              "frequency": "Weekly"
            }
          },
          "spouse_applicant_id": null,
          "phone_number": null,
          "email": null,
        }
      },
      "privacy_consent": {
        "consent_type": "Not Given",
        "verbal_consent": {
          "mothers_maiden_name": null,
          "mothers_birth_place": null
        },
        "hubspot_privacy_accepted_date": null,
        "zink_consent_accept_date": null,
      },
      "previous_privacy_consent": {
        "consent_type": "Not Given",
        "verbal_consent": {
          "mothers_maiden_name": null,
          "mothers_birth_place": null
        },
        "hubspot_privacy_accepted_date": null,
        "zink_consent_accept_date": null,
      },
      "addresses": {
        "current": newAddressHistory(),
        "previous": [ ],
      },
      "employments": {
        "current": [ newEmployment() ],
        "previous": [ ],
      },
      "incomes": [ newIncome('Other') ],
      "expenses": [
         newExpense('Groceries'),
         newExpense('Transport'),
         newExpense('Utilities'),
         newExpense('Telecommunications'),
         newExpense('Insurance'),
         newExpense('Child Support'),
         newExpense('Entertainment'),
      ],
      "assets": [
        newAsset('Credit Card'),
        newAsset('Personal Loan'),
        newAsset('Home'),
        newAsset('Home Contents'),
        newAsset('Car'),
        newAsset('Savings'),
      ],
      "references": [],
      "veda_report": null,
      "previous_veda_report": null,
      "hubspot": {
        "vid": null,
      },
    };
}

function newBroker() {
    return {
        "id": null,
        "user_id": "",
        "first_name": "",
        "last_name": "",
        "prefered_name": "",
        "postcode": "",
        "personal_email": "",
        "broker_phone": "",
        "broker_esign_id": "",
        "lender_credentials": [],
        "state": "",
        "employment_type": "",
        "seating": "",
        "target": "",
        "abn": "",
        "start_date": null,
        "grace_period_end_date": null,
        "end_date": null,
        "veda_rate": 0,
        "lead_rate": 0,
        "credit_rep_no": "0",
        "maclease_token": null,
        "xeal_unique_id": null,
        "xero_tracking_code": null,
        "maclease_id": null,
        "pepper_code": null,
        "money3_id": null,
        "liberty_id": null,
        "latitude_id": null,
        "xero_contact_id": null,
        "rcti_enabled": 0,
        "trigger_1": "0",
        "rate_1": "0",
        "ref_name_1":"",
        "ref_id_1":"",
        "ref_name_2":"",
        "ref_id_2":"",
        "ref_name_3":"",
        "ref_id_3":"",
        "ref_name_4":"",
        "ref_id_4":"",
        "trigger_2": "0",
        "rate_2": "0",
        "trigger_3": "0",
        "rate_3": "0",
        "trigger_4": "0",
        "rate_4": "0",
        "trigger_digital": "0",
        "rate_digital": "0",
        "rate_cc_digital": "0",
        "deleted_at": null,
        "user": {
            "id": null,
            "entity_id": null,
            "user_pod_id": "",
            "email": "",
            "utc_offset": 0,
            "first_name": "",
            "last_name": "",
            "created_by": 0,
            "updated_by": 0,
            "deleted_at": null,
            "user_pod": {
                "id": null,
                "name": "",
                "description": "",
                "created_by": 0,
                "updated_by": 0,
            }
        },
        'hubspot': {
          'role': null,
          'address': null,
          'qr_code_url': null,
          'affiliate_id': null,
          "broker_logo": "",
          "broker_review_link": "",
          "facebook_url": "",
          "google_review_link": "",
          "instagram_url": "",
          "twitter_url": "",
          "linkedin_url": "",
          'branding_type': "",
        },
        "charge_setting":newChargeSetting(),
        "income_trigger_count": 0,
    }
}

function newChargeSetting()
{
  return [
    {'id': 'charge_veda', 'name': 'Charge for Veda', 'is_enabled': false},
    {'id': 'charge_ppsr', 'name': 'Charge for PPSR', 'is_enabled': false},
    {'id': 'charge_landtitle', 'name': 'Charge for Land Title', 'is_enabled': false},
    {'id': 'charge_bankstatement', 'name': 'Charge for Bank Statement', 'is_enabled': false},
    {'id': 'charge_docusign', 'name': 'Charge for DocuSign', 'is_enabled': false},
    {'id': 'charge_voi', 'name': 'Charge for VOI', 'is_enabled': false},
    {'id': 'charge_onescore', 'name': 'Charge for One Score', 'is_enabled': false},
    {'id': 'charge_auction', 'name': 'Charge for Auction', 'is_enabled': false},
  ];
}

function newApplication(){
    return {
      "version": "1.0",
      "loan": {
        "id": null,
        "type": null,
        "consumer": null,
        "is_from_consumer": false,
        "status": {
          "stage": 'New',
          "status": 'New',
          "reason": null,
          "comment": null,
        },
        "buy_period": "",
        "purpose": "",
        "genius_broker_email": "docs@1800approved.com.au",
        "requested": {
          "amount": null,
          "term": 60
        },
        "submission": {
          "current": newSubmission(),
          "previous": [],
          "active": newSubmission(),
        },
        "affordability": {
          "amount": null,
          "frequency": "Monthly"
        },
        "comments": [],
        "asset": {
          "type": "Vehicle",
          "vehicle": newLoanSecurity('V'),
          "marine" : newLoanSecurity('M'),
          "equipment": newLoanSecurity('E'),
          "secured": newLoanSecurity('S'),
          "unsecured": newLoanSecurity('P'),
          "leisure": newLoanSecurity('L'),
          "cashflow": newLoanSecurity('C')
        },
        "insurances": [
          newInsurance('CCI'),
          newInsurance('GAP'),
          newInsurance('MVI', null, true),
          newInsurance('WTY'),
        ],
        "clawbacks": [],
        "marketing_source": "",
      },
      "applicants": [
        newApplicant(),
      ],
      "permissions": {
        "view-metadata": false,
        "view": false,
        "update": false,
        "delete": false,
        "transfer": false,
        "archive": false,
        "un-archive": false,
        "view-assessment": false,
        "process-settlement": false,
        "view-settlement": false,
        "update-settlement": false,
        "view-document": false,
        "update-document-type": false,
        "re-run-veda": false
      },
      "owners": [],
    };
}

function newSubmission() {
  return {
    "id": null,
    "comment": null,
    "naf": null,
    "rate": null,
    "term": null,
    "repayments": null,
    "monthly_account_fee": null,
    "payment_frequency": "Monthly",
    "balloon_amount": null,
    "product": {
      "id": null,
      "product_name": null,
      "lender_name": null,
      "product_type": null,
      "asset_type": null,
      "application_type": null,
    }
  };
}

function newLoanSecurity(securityId) {
  return {
    "body": "Sedan",
    "value": null,
    "deposit": null,
    "new": false,
    "private_sale": 2,
    "pre_approval": false,
    "make_year": null,
    "model_year": null,
    "make": null,
    "model": null,
    "registration": null,
    "state": null,
    "vin": null,
    "odometer": null,
    "nvic": null,
    "trade_in_value":null,
    "deposit_value":null,
    "accessories_cost": null,
    "purchase_cost": null,
    "hin": null,
    "requested_amount": null,
    "loan_asset_type_id": securityId,
    "supplier_name": null,
    "supplier_contact_number": null,
    "supplier_abn": null,
    "supplier_contact_email": null,
    "engine_number": null,
    "build_date": null,
    "completion_date": null,
  };
}

function newUploadDocument(type='') {
  return {
    "document_type": type,
    "file_name": null,
    "verify": false,
  }
}

function newIntroducer() {
  return {
    "id": null,
    "trading_name": "",
    "bdm_broker": {
      'id': '',
      'name': '',
      'email': ''
    },
    "lead_cost": null,
    "income_tracking_code": "",
    "introducer_class": "",
    "introducer_code": "",
    "tracking_code": "",
    "xero_contact_code": "",
    "contact_person_name": "",
    "contact_number": "",
    "expense_tracking_code": "",
    "hubspot": {
      'company_default_email': "",
      'call_back_time_url': "",
      'loan_purpose': "",
      'co_branding_opt_in': false,
      'is_veda_disabled': false,
      'branding_type': "",
      'broker_logo_url': "",
      'referrer_logo_url': "",
      'background_image_url': "",
      'pod_name': "",
      'facebook_url': "",
      'instagram_url': "",
      'google_review_link': "",
      'linkedin_url': "",
      'twitter_url': "",
      'affiliate_id': "",
      'page_title': "",
      'page_path': "",
      'qr_code_url': "",
      'post_code': "",
      'contact_name': "",
      'broker': {
        'name': "",
        'id': "",
        'user_id': "",
      }
    },
    "commission": {
      "id": null,
      "trigger_type": "percentage",
      "trigger_1": 0,
      "rate_1": 0,
      "trigger_2": 0,
      "rate_2": 0,
      "trigger_3": 0,
      "rate_3": 0,
      "trigger_4": 0,
      "rate_4": 0
    },
    "user": {
      "id": null,
      "user_pod_id": null,
      "email": "",
      "first_name": "",
      "last_name": "",
      "user_pod": {
        "id": null,
        "name": "",
        "description": ""
      }
    },
    "address": newAddress(),
    "bank": {
      "id": null,
      "bsb": "",
      "account_number": "",
      "account_name": ""
    },
    "webhook_url": null,
    "webhook_schema": null,
    "referral_cs_dealer_id": null,
    "referral_opted_cs": false,
    "referral_agreement": false,
    "referral_new_lead_notification": false,
    "auction_exclusion": false,
    "referral_comments": null,
    "referral_title": null,
    "referral_website_url": null,
    "referral_abn": null,
    "referral_asset_type": null
  }
}

function newGlassPrice() {
    return {
        "id": null,
        "code": "",
        "month": "",
        "make": "",
        "model": "",
        "variant": "",
        "series": "",
        "style": "",
        "injection": "",
        "engine_cc": "",
        "engine_capacity": "",
        "transmission": "",
        "cylinders": "",
        "avg_price": "",
        "a_avg_price": "",
        "b_avg_price": "",
        "width": "",
        "nvic": "",
        "year": "",
        "bt": "",
        "et": "",
        "tt": "",
    }
}

function newPod() {
  return {
    'pod_code': null,
    'name': null,
    'description': null,
    'parent_id': null,
    'pod_abn': null,
    'pod_target': null,
    'pod_contact_person': null,
    'pod_contact_email': null,
    'pod_status': null,
    'id': null,
    'acn': null,
    'acl': null,
    'bsb': null,
    'account_number': null,
    'address': null,
    'contact_number': null,
    'pod_owner_id': null,
    'xero_contact_code': null,
    'bill_in_bulk': false,
    'birdeye_enable': false,
    'birdeye_url': null,
    'trigger_1': 0,
    'trigger_2': 0,
    'trigger_3': 0,
    'trigger_4': 0,
    'rate_1': 0,
    'rate_2': 0,
    'rate_3': 0,
    'rate_4': 0,
    'vbi_trigger_1': 0,
    'vbi_trigger_2': 0,
    'vbi_trigger_3': 0,
    'vbi_trigger_4': 0,
    'vbi_rate_1': 0,
    'vbi_rate_2': 0,
    'vbi_rate_3': 0,
    'vbi_rate_4': 0,
    'webhook_url': null,
    'webhook_schema': null,
    'income_trigger_count': 0,
    'local_radius': null,
  }
}

function newReportingFilters()
{
  return {
    'basedOnSettlement': false,
    'force': false,
    'export': false,
    'date_filter': {
      'start_date': moment().startOf('month').format('YYYY-MM-DD'),
      'end_date': moment().format('YYYY-MM-DD'),
    },
    'dropdown': {
      'pod': "All",
      'child_pods': [],
      'broker': ["All"],
      'lender': ["Exclude Floorplan Lenders"],
      'introducer': "",
      'asset_type': ["All"],
      'roles' : null,
      'model_year': "All",
      'make': "All",
      'model': "All",
    },
  }
}

function newLenderCredential()
{
  return {
    'username': null,
    'password': null,
    'lender': null,
    'id': null,
  };
}

function newService()
{
  return {
    'id': null,
    'name': null,
    'enabled': false,
    'opt_in': false,
  };
}

function newOptInService()
{
  return {
    'id': null,
    'enabled': false,
    'user': {
      'id': null,
      'name': {
        'first_name': '',
        'last_name': ''
      }
    },
    'zink_service': {
      'description': null,
      'enabled': false,
      'id': null,
      'name': null
    }
  };
}

function newAuction()
{
  return {
    'auction_id': null,
    'auction_name': null,
    'auction_timer': null,
    'restart_timer': null,
    'close_timer': null,
    'auction_grade_a': null,
    'auction_grade_b': null,
    'auction_grade_c': null,
    'auction_buy_now': null,
    'auction_description': null
  };
}

function newDocumentType(){
    return {
      'name':null,
      'description':null,
      'accepted_file_type':null,
      'active':'Yes',
      'require_authentication':'No'
    }
}

function newLender() {
  return {
    'adp_lender_id': null,
    'lender_name': null,
    'product_type': null,
    'application_type': null,
    'asset_type': null,
    'submission_api': null,
    'order': null,
    'show_in_reporting': null,
    'push_to_xero': null,
    'is_floorplan': null,
    'pod_applied': ['All'],
  }
}

function newProduct() {
  return {
    'id': null,
    'lender_id': null,
    'adp_product_id': null,
    'adp_lender_id': null,
    'lender_xero_contact_id': null,
    'product_name': null,
    'lender_name': null,
    'product_type': null,
    'application_type': null,
    'asset_type': null,
    'submission_api': null,
    'order': null,
    'placeholder_api': null,
    'submission_email': null,
    'submission_url': null,
    'default_broker_fee': null,
    'default_comission_percentage': null,
    'default_comission_amount': null,
  }
}
function newAdjustment() {
  return {
    'adjustment_type': null,
    'amount': null,
    'description': null,
    'pod_data' : {
      'id' : null,
      'name' : null
    },
    'broker_data' : {
      'id' : null,
      'name' : null
    },
    'bill_data': null,
  }
}

function newClawback() {
  return {
    "type": null,
    "amount": 0,
    "created_at": moment().format('YYYY-MM-DD')
  };
}

function newJourneyStep() {
  return {
    "id": null,
    "name": null,
    "key": null,
    "title": null,
    "description": null,
    "conditions": [],
    "parent": null,
  }
}

export {
    schema,
    newPhone,
    newEmail,
    newIdentification,
    newAddress,
    newAddressHistory,
    newEmployment,
    newIncome,
    newDocuRoleName,
    newExpense,
    newAsset,
    newAuction,
    newReference,
    newComment,
    newApplicant,
    newApplication,
    newBroker,
    newUploadDocument,
    newIntroducer,
    newGlassPrice,
    newPod,
    newReportingFilters,
    newLenderCredential,
    newLender,
    newProduct,
    newDocumentType,
    newAdjustment,
    newSubmission,
    newClawback,
    newService,
    newOptInService,
    newJourneyStep,
}
